<template>
  <div class="home" :class="[scrollContent ? 'scroll-content' : '']">
    <transition appear name="slide-fade">
      <div class="home-content">
        <svg width="794px" height="1513px" viewBox="0 0 794 1513">
          <defs>
              <linearGradient x1="36.2690249%" y1="0%" x2="63.7309751%" y2="100%" id="linearGradient-1">
                  <stop stop-color="#232323" offset="0%"></stop>
                  <stop stop-color="#0C0C0C" offset="100%"></stop>
              </linearGradient>
              
          </defs>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <mask>
                  <path d="M0.714384419,1513 C179.571461,1513 269,1513 269,1513 C269,1513 317.78376,1302.32552 415.351279,880.976575 L430.861703,821.043246 L448.56598,752.689659 L462.562684,698.700344 L478.450498,637.479573 L488.491931,598.827185 L500.424473,552.943342 L507.253733,526.709911 L518.085388,485.148987 L528.22899,446.289886 L533.984885,424.271301 L543.0276,389.735119 L548.122963,370.310286 L556.064791,340.097023 L561.922855,317.871725 L567.340564,297.375596 L571.114863,283.138264 L575.761952,265.668178 L578.958285,253.700379 L581.906919,242.705236 L584.607854,232.682751 L586.270866,226.541459 L587.82379,220.832458 L589.266625,215.55575 L590.599371,210.711333 C590.812322,209.939955 591.020685,209.186588 591.224461,208.451234 L592.392075,204.255256 C592.762931,202.928645 593.115439,201.674082 593.449599,200.491569 L594.397035,197.160173 C594.545767,196.640965 594.689912,196.139769 594.82947,195.656585 C615.763154,123.179004 661.230961,20.9928922 793.549504,0.03569377 L0.674701945,0 L0.714384419,1513 Z" id="path-2"></path>
              </mask>              
          </g>
        </svg>
        <HomeShape />
        <div ref="content">
          <transition appear name="slide-fade"
            ><img
              style="transition-delay: 0s"
              src="@/assets/logo/logo_secondary.svg"
              alt=""
          /></transition>
          <transition appear name="slide-fade">
            <div style="transition-delay: 0.1s" class="statement">
              <div class="strong">
                <span>Las<br />Vegas</span>
              </div>
              <p class='bottom'>Entertainment</p>
            </div>
          </transition>
          <transition appear name="slide-fade">
            <Button
              style="transition-delay: 0.3s"
              to="/home/the-stadium"
              title="The Stadium"
            ></Button>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from "@/patterns/Button.vue";
import HomeShape from "@/components/svg/home-shape.vue";
export default {
  name: "Home",
  components: { Button, HomeShape },
  data: () => ({ scrollContent: false }),
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
svg {
  position: absolute !important;
  top: 0;
  left: -1px;
  &.blur {
    backdrop-filter: blur(13px);
    clip-path: url(#clip);
  }
}
.home {
  background-image: url("~@/assets/images/bg_home.jpg");
  background-size: cover;
  background-position: center;
  &.scroll-content .home-content {
    display: block;
    overflow: auto;
    height: calc(100% - 55px);
  }
  p {
    color: #ffffff;
    font-family: Gotham;
    font-size: 1em;
    font-weight: 500;
    letter-spacing: 10px;
    text-transform: uppercase;
  }
  .strong {
    font-family: "Gotham Ultra";
    font-size: 6.5em;
    letter-spacing: 0;
    line-height: 0.8em;
    text-shadow: 0 0 36px rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    color: #fff;
    span {
      padding: 24px 0;
      display: inline-block;
    }
    &::before,
    &::after {
      content: " ";
      display: block;
      height: 1px;
      width: 365px;
      background: linear-gradient(
        133.07deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}
.home-content {
  padding-left: 70px;
  height: calc(100% - 50px);
  display: flex;
  align-items: center;
  max-width: 795px;
  position: relative;
  overflow: hidden;
  > div {
    position: relative;
  }
}

.statement {
  margin-top: 55px;
  margin-bottom: 60px;
  .top {
    padding-bottom:1.25em;
  }
  .bottom {
    padding-top:1.25em;
  }
}
</style>
